enum DegreeLevel {
  UNDERGRAD = 'undergrad',
  MASTERS = 'masters',
  DOCTORAL = 'doctoral',
  UNKNOWN = 'unknown',
}

export default DegreeLevel;
